/** модуль информации о странице */
export default {
    /**
     * состояния
     * @property {string} currentViewName - название текущей страницы
     */
    state: {
        currentViewName: ''
    },
    /**
     * мутации
     */
    mutations: {
        /**
         * установить текущее название
         * @param {object} state - объект состояний
         * @param {string} currentViewName - текущее название
         */
        setCurrentViewName(state, currentViewName) {
            state.currentViewName = currentViewName;
        }
    }
}